import { getCurrentDateWithOutHyphen } from "./dateParser";

export const documentTitle = (name) => {
  return (document.title = `SKV Silvers - ${name}`);
  // return (document.title = `TN Tech - ${name}`);
};

export const generateUniqueId = () => {
  return `${getCurrentDateWithOutHyphen()}-${Math.floor(Math.random() * 1000)}`;
};
